import script from "./VTableRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./VTableRow.vue?vue&type=script&setup=true&lang=ts"

import "./VTableRow.vue?vue&type=style&index=0&id=0fc487cf&lang=scss"

const __exports__ = script;

export default __exports__